import { canRefreshCache } from '@/utils/pwaUpdatePolicy';

export async function refresh(): Promise<void> {
  if (!canRefreshCache()) return;

  try {
    // Delete all caches associated with our app
    const cacheKeys: string[] = await window.caches.keys();
    await Promise.all(cacheKeys.map((key: string) => window.caches.delete(key)));

    // Unregister any service workers associated with our app
    if ('serviceWorker' in navigator) {
      const registrations: readonly ServiceWorkerRegistration[] = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((sw: ServiceWorkerRegistration) => sw.unregister()));
    }

    // Reload the page to trigger install of new service worker and re-cache
    setTimeout(() => window.location.reload(), 300);
  } catch (e: unknown) {
    console.log(e);
  }
}